import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type BackgroundImageCtaProps = CtaShellProps

export function BackgroundImageCta(props: BackgroundImageCtaProps) {
	return <CtaShell {...props} layout="background" background={props.background ?? { type: "image", image: { src: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1800&q=88", alt: "Workspace background" } }} />
}